import { Divider, Text, useTheme } from '@ui-kitten/components';
import { Platform, StyleSheet, View, ViewProps } from 'react-native';
import { ProfileIcons } from '../profileMe/ProfileIcons';
import React from 'react';
import SelectDropdown from 'react-native-select-dropdown';
import { UIHelper as uh } from '../../core';
import { useAppStore } from 'src/core/store';

interface TenantDropdownListProps extends ViewProps {
  caption: string;
  data: Array<string>;
  selectedIndex: number;
  selectItem: (index: number) => void;
}

const TenantDropdownList = (props: TenantDropdownListProps) => {
  const th = useTheme();
  const theme = useAppStore((state) => state.theme);
  const condColors = {
    input: uh.getHex(th, theme, 'color-basic-100', 'color-basic-1100')
  };

  const styleContainer = StyleSheet.create({
    container: {
      width: 200
    },
    caption: {
      marginBottom: uh.h2DP(4)
    },
    dropdownStyle: {
      marginTop: Platform.OS == 'android' ? -25 : 0,
      height: 48 * props.data.length,
      borderRadius: 8,
      borderColor: 'transparent',
      backgroundColor: uh.getHex(th, theme, 'color-basic-100', 'color-basic-900')
    },
    dropdownBtn: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      width: '100%',
      backgroundColor: condColors.input,
      paddingHorizontal: 4,
      height: 48,
      borderRadius: 8
    },
    dropdownBtnTxt: {
      textAlign: 'left',
      marginLeft: uh.w2DP(10),
      fontSize: 14,
      color: th['text-basic-color']
    },
    icon: {
      width: 20,
      height: 20
    },
    rowContainer: {
      backgroundColor: uh.getHex(th, theme, 'color-basic-100', 'color-basic-900'),
      height: 48,
      borderBottomColor: 'transparent',
      justifyContent: 'center'
    },
    rowText: {
      height: 48,
      color: th['text-basic-color']
    },
    childContainer: {
      flex: 1,
      justifyContent: 'center'
    },
    childText: {
      marginLeft: uh.w2DP(14),
      fontSize: 14,
      textAlign: 'left',
      height: 28,
      marginTop: uh.h2DP(14),
      color: th['text-basic-color']
    },
    divider: {
      marginTop: uh.h2DP(9),
      backgroundColor: th['color-basic-600']
    }
  });

  const renderButton = (selectedItem: string, isOpened: boolean) => (
    <View style={styleContainer.dropdownBtn}>
      <Text
        style={styleContainer.dropdownBtnTxt}
        category="c2"
        accessible={true}
        accessibilityLabel={`${selectedItem} dropdown input`}
        testID={`${selectedItem}_dropdown_input`}>
        {selectedItem || props.data[props.selectedIndex]}
      </Text>
      {isOpened ? (
        <ProfileIcons.UpIcon style={styleContainer.icon} fill={th['color-basic-600']} />
      ) : (
        <ProfileIcons.DownIcon style={styleContainer.icon} fill={th['color-basic-600']} />
      )}
    </View>
  );

  const renderItem = (item: string, index: number, isSelected: boolean) => (
    <View style={styleContainer.rowContainer}>
      <View style={styleContainer.childContainer}>
        <Text
          style={[styleContainer.childText, isSelected && { fontWeight: 'bold' }]}
          category="c2"
          accessible={true}
          accessibilityLabel={`Dropdown ${item}`}
          testID={`dropdown_${index}`}>
          {item}
        </Text>
      </View>
      {index < props.data.length - 1 && <Divider style={styleContainer.divider} />}
    </View>
  );

  return (
    <View style={[props.style]}>
      {props.caption != undefined && (
        <Text category="label" appearance="hint" style={styleContainer.caption}>
          {props.caption}
        </Text>
      )}
      <SelectDropdown
        data={props.data}
        onSelect={(_selectedItem, index) => {
          props.selectItem(index);
        }}
        renderButton={renderButton}
        renderItem={renderItem}
        dropdownStyle={styleContainer.dropdownStyle}
        defaultValueByIndex={props.selectedIndex}
        statusBarTranslucent={false}
        showsVerticalScrollIndicator={false}
      />
    </View>
  );
};

export default TenantDropdownList;
